<div class="row responsive-padding" *ngFor="let country of countries">
  <div class="col-sm-12 col-md-4 text-center text-md-start">
    <div class="jumbotron">
      <app-country-flag  [countryImage]="country['flagImage']"></app-country-flag>
          {{country['name']}}
      </div>
      </div>
      <div class="col-sm-12 col-md-8 text-center text-md-start ">
        <div class="jumbotron">
          <span class="ms-3 mt-2" *ngFor="let subject of country['levels']">
            <a [routerLink]="['/study/worksheet/',subject['id']]">
              {{subject['name']}}
            </a></span>
        </div>
        </div>

  </div>


